"use client";
import Skeleton from "react-loading-skeleton";
import {
  useFetchMainAccessPoint,
  useOrganisationCategories,
  generateAbbreviation,
} from "../../lib/util";
import styles from "./index.module.css";
import EmptyState from "../common/EmptyState";
import { useEffect, useState } from "react";
import Carousel from "../carousel/carousel";
import { useAppDispatch } from "../slice/hooks";
import { setActiveCategory } from "../slice/category-slice";

const CARD_WIDTH = "34rem";
const CARD_HEIGHT = "27rem";

const LoadingCategoryCard = ({ style }) => {
  return (
    <div
      style={{
        width: CARD_WIDTH,
        height: CARD_HEIGHT,
        borderRadius: 8,
        marginRight: "0.5rem",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        gap: "1rem",
        ...style,
      }}
    >
      <div style={{ width: "10rem", margin: "0 auto" }}>
        <Skeleton width={"100%"} height={20} />
      </div>

      <div style={{ flex: 1, minHeight: 0 }}>
        <Skeleton
          width={"30rem"}
          height={"100%"}
          style={{ borderRadius: 8, display: "block" }}
        />
      </div>
    </div>
  );
};

const OrganisationCategories = ({ acc, token, handleSwitch }) => {
  const orgId = acc?.profileId;
  const accessPointId = acc?.accessPointId;
  const dispatch = useAppDispatch();

  const { data, isLoading } = useOrganisationCategories(
    orgId,
    token,
    accessPointId,
  );

  if (isLoading) {
    return (
      <>
        {Array.from({ length: 5 }).map((_, i) => (
          <LoadingCategoryCard key={i} />
        ))}
      </>
    );
  }

  const categories = data?.productCategories || [];
  if (!categories.length) {
    return (
      <EmptyState>
        There are no categories available for this Organisation
      </EmptyState>
    );
  }

  return categories.map((category) => {
    const hasProducts = category.products && category.products.length > 0;
    // Build media array for carousel
    const media = category.products
      ?.map((product) => product.media?.[0])
      .filter(Boolean)
      .map((m) => ({
        mediaUrl: m.mediaUrl,
        mediaThumb: m.mediaThumb,
        mediaName: m.mediaName,
        mediaType: m.mediaType,
        mediaExt: m.mediaExt,
        mediaWidth: m.mediaWidth,
        mediaHeight: m.mediaHeight,
        mediaTime: m.mediaTime,
        _id: m._id,
      }));

    return (
      <div
        key={category.categoryId}
        className={styles.organisationCategory}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(setActiveCategory(category.productCategoryId));
          handleSwitch(acc);
        }}
      >
        <h4>{category.name}</h4>

        {hasProducts ? (
          <div style={{ overflow: "hidden", padding: "1.5rem" }}>
            <Carousel
              media={media}
              enablePreview={false}
              autoscroll={true}
              hideThumb={true}
              inMarketPlace={true}
            />
          </div>
        ) : (
          <div
            style={{
              width: "30rem",
              height: "29rem",
              padding: "2rem 2.5rem",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f0f0f0",
                borderRadius: "15px",
                marginRight: "0.5rem",
                fontSize: "5rem",
                color: "#444",
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              {generateAbbreviation(category.name)}
            </div>
          </div>
        )}
      </div>
    );
  });
};

export default OrganisationCategories;
